(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("classnames"), require("prop-types"), require("@swrve/icons"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "classnames", "prop-types", "@swrve/icons", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["@swrve/core"] = factory(require("react"), require("classnames"), require("prop-types"), require("@swrve/icons"), require("react-router-dom"));
	else
		root["@swrve/core"] = factory(root["react"], root["classnames"], root["prop-types"], root["@swrve/icons"], root["react-router-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__156__, __WEBPACK_EXTERNAL_MODULE__310__, __WEBPACK_EXTERNAL_MODULE__99__, __WEBPACK_EXTERNAL_MODULE__751__, __WEBPACK_EXTERNAL_MODULE__128__) => {
return 